var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useSchedulerViewsContext } from '../../../main';
import { useSchedulerActiveViewContext } from '../../../context';
import { useLocalization } from '@progress/kendo-react-intl';
import { DropDownButton, ButtonGroup } from '@progress/kendo-react-buttons';
import { ViewSelectorItem } from './ViewSelectorItem';
/** @hidden */
export var ViewSelectorList = React.forwardRef(function () {
    var views = useSchedulerViewsContext();
    var _a = useSchedulerActiveViewContext(), activeViewName = _a[0], setActiveViewName = _a[1];
    var activeView = views.find(function (v) { return v.props.name === activeViewName; });
    var localization = useLocalization();
    var handleItemClick = React.useCallback(function (event) {
        if (!setActiveViewName) {
            return;
        }
        event.syntheticEvent.preventDefault();
        setActiveViewName(event.item.name);
    }, [setActiveViewName]);
    return (React.createElement("div", { className: "k-scheduler-views-wrapper" },
        (activeView) && (React.createElement(DropDownButton, { className: "k-views-dropdown", onItemClick: handleItemClick, popupSettings: { popupClass: 'k-scheduler-toolbar' }, textField: "title", items: views.map(function (v) { return (__assign({}, v.props, { selected: v.props.name === activeViewName, title: typeof v.props.title === 'function'
                    ? v.props.title.call(undefined, localization)
                    : v.props.title })); }), text: (React.createElement(React.Fragment, null,
                typeof activeView.props.title === 'function'
                    ? activeView.props.title.call(undefined, localization)
                    : activeView.props.title,
                React.createElement("span", { className: "k-icon k-i-arrow-60-down" }))) })),
        React.createElement(ButtonGroup, { className: "k-scheduler-views" }, views.map(function (view) { return (React.createElement(ViewSelectorItem, { key: view.props.name, view: view.props })); }))));
});
//# sourceMappingURL=ViewSelectorList.js.map